var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0469 7.5625L15.0469 12.5625L10.0469 7.5625L7.54688 10.0625L12.5469 15.0625L7.54688 20.0625L10.0469 22.5625L15.0469 17.5625L20.0469 22.5625L22.5469 20.0625L17.5469 15.0625L22.5469 10.0625L20.0469 7.5625ZM26.9719 24.1375C28.8969 21.6125 30.0469 18.4625 30.0469 15.0625C30.0469 6.7875 23.3219 0.0625 15.0469 0.0625C6.77188 0.0625 0.046875 6.7875 0.046875 15.0625C0.046875 23.3375 6.77188 30.0625 15.0469 30.0625C18.4719 30.0625 21.6219 28.9125 24.1469 26.9625L31.1219 33.9375L33.9469 31.1125L26.9719 24.1375ZM14.7969 26.0375C8.59688 26.0375 3.57188 20.9875 3.57188 14.7875C3.57188 8.5875 8.62187 3.5375 14.7969 3.5375C20.9719 3.5375 26.0469 8.5875 26.0469 14.7875C26.0469 20.9875 20.9719 26.0375 14.7969 26.0375Z",
    fill: "currentColor",
    fillOpacity: 0.15
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/no-data.53992663c931b8dd9ac332c6c24c4d9b.svg";
export { ForwardRef as ReactComponent };